'use client';

import type { LaunchPromoConfig } from '@/lib/payments/pricing-fetcher';
import { useAppDispatch } from '@/lib/redux/hooks';
import { setLaunchPromo, setPlans } from '@/lib/redux/slices/pricingSlice';
import type { ServerPlan } from '@/types/pricing';
import { useEffect } from 'react';

interface PricingInitializerProps {
  plans: ServerPlan[];
  launchPromo: LaunchPromoConfig;
}

/**
 * Initializes pricing plans + backend-owned launch-promo config in Redux
 * from server-side fetched data. The backend (settings.LAUNCH_PROMO_*) is
 * the single source of truth — the frontend no longer reads
 * NEXT_PUBLIC_LAUNCH_PROMO_* env vars.
 */
export default function PricingInitializer({
  plans,
  launchPromo,
}: PricingInitializerProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (plans && plans.length > 0) {
      dispatch(setPlans(plans));
    }
    dispatch(setLaunchPromo(launchPromo));
  }, [dispatch, plans, launchPromo]);

  return null;
}
